import { CompanyConfigService } from "./shared/services/company-config.service";


export function initializeApp(
  companyConfigService: CompanyConfigService
) {
  return () => companyConfigService.load();
}
